module.exports = __webpack_public_path__ + "img/1-7.5f5d4404.svg";